<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
         <el-breadcrumb-item :to="{ path: '/research/:id', query: {id: researchId} }">研究院生态</el-breadcrumb-item>
        <el-breadcrumb-item>出版物列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>出版物</span>
          <span class="comment_btn" :class="!topOnOff ? 'act' : ''" @click="sortBtn('time')">时间排序</span>
          <span class="comment_btn" :class="topOnOff ? 'act' : ''" @click="sortBtn('hot')">热度排序</span>
          <el-divider></el-divider>
        </p>
      </div>
      <none-view v-if="bookList.length === 0" :login="load.login" :loading="load.loading" :data="bookList" :text="load.text"></none-view>
      <div class="book_list_box">
        <div v-for="(item, index) in bookList" :key="item.id" class="book_list_item lf">
          <div class="book_list_left">
            <img :src="item.book_img" alt="">
          </div>
          <div class="book_list_right">
            <div class="book_list_title" @click="jump(item.list_id)">
              {{item.title}}
            </div>
            <div class="book_list_other">
              <span><i>{{item.read}}</i> 次浏览</span>
              <el-divider direction="vertical"></el-divider>
              <span><i>{{item.favorites}}</i> 次收藏</span>
            </div>
            <div class="book_list_button">
              <div class="my_icon_box lf">
                <button v-show="item.is_collection === 0"
                class="greenglga_btn"
                @click="doFavorite(item.list_id, item.is_collection, index)">
                  <i class="shoucang"></i>
                  <span>收藏</span>
                </button>
                <button v-show="item.is_collection === 1"
                :class="hoverIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
                @mouseenter="hoverIndex = index"
                @mouseleave="hoverIndex = ''"
                @click="doFavorite(item.list_id, item.is_collection, index)">
                  <span v-show = "hoverIndex !== index">已收藏</span>
                  <span v-show = "hoverIndex === index">取消收藏</span>
                </button>
              </div>
            </div>
            <div class="book_list_bottom">
              <p>作者：{{item.author}}</p>
              <p>出版社：{{item.press}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="bookList.length > 0" class="page_box">
        <page-view :limit="bookListPage.limit" :list="bookList" :type="bookListPage.sort" @pageType="morePage"></page-view>
      </div>
    </div>
  </div>
</template>

<script>
import page from '../Public/page.vue'
import none from '../Public/none.vue'
export default {
  components: {
    pageView: page,
    noneView: none
  },
  data () {
    return {

      hoverIndex: '', // 获取当前鼠标移入下标
      topOnOff: false, // 栏目切换
      load: {
        login: false, // 是否需要验证登陆
        loading: true, // 加载动画开关
        txet: '暂无出版物' // 列表为空时的提示信息
      },
      bookList: [], // 项目路演列表
      bookListPage: { // 项目路演列表分页参数
        limit: 6,
        page: 1,
        research_id: '', // 研究院id
        sort: 2 // 1热度排序 2时间排序
      }
    }
  },
  created () {
    this.researchId = this.$route.query.id
    this.getBookList()
  },
  methods: {
    // 获取列表
    getBookList () {
      const vueThat = this
      vueThat.bookListPage.research_id = vueThat.researchId
      vueThat.myApi.getBookList(vueThat.bookListPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.load.loading = false
          vueThat.bookList = [...vueThat.bookList, ...res.data.data]
        }
      })
    },
    // 列表排序
    sortBtn (type) {
      const vueThat = this
      vueThat.bookList = [] // 重置评论列表
      vueThat.loading = true // 开启加载动画
      vueThat.bookListPage.page = 1
      if (type === 'time') {
        vueThat.topOnOff = false
        vueThat.bookListPage.sort = 2
        vueThat.getBookList()
      } else {
        vueThat.topOnOff = true
        vueThat.bookListPage.sort = 1
        vueThat.getBookList()
      }
    },
    // 页面跳转
    jump: function (rid) {
      const routeData = this.$router.resolve({
        path: '/bookDetail/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 加载更多
    morePage (num, type) {
      const vueThat = this
      vueThat.bookListPage.page = num
      vueThat.bookListPage.sort = type
      vueThat.getBookList()
    },
    // 文章收藏功能
    doFavorite (rid, isCollection, index) {
      const vueThat = this
      if (isCollection === 0) {
        vueThat.myApi.doFavorite({ list_id: rid }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '收藏成功！',
              type: 'success'
            })
            vueThat.bookList[index].is_collection = 1
            vueThat.bookList[index].post_favorites += 1
          }
        })
      } else {
        vueThat.myApi.cancelFavorite({ list_id: rid }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '取消收藏成功！',
              type: 'success'
            })
            vueThat.bookList[index].is_collection = 0
            vueThat.bookList[index].post_favorites -= 1
          }
        })
      }
    }
  }
}
</script>

<style>
</style>
